export const changeDropdownLanguage = (
  rigiLanguage: string,
  language: string,
  loadPath: string,
) => {
  window.dispatchEvent(
    new CustomEvent('changeDropdownLanguage', {
      detail: {
        rigiLanguage,
        language,
        loadPath,
      },
    }),
  )
}
